import React, { useState, useEffect } from 'react';
import './Header.css';
import { TopRightBar, Mode, HeaderInput, Logo } from './Component';
import { MainLoader } from 'CommonComponent';

const Header = () => {

  return (
    <>
      <div className='pt-3 d-flex justify-content-between align-items-center px-4'>
        <div className='d-flex align-items-center'>
          {/* Pass theme to Logo component */}
          <Logo />
          <HeaderInput />
        </div>
        <div>
          {/* Pass theme and setTheme to Mode for toggling */}
          <Mode />
        </div>
        <div>
          <TopRightBar />
        </div>
      </div>
      <MainLoader />
    </>
  );
};

export default Header;
